<script setup lang="ts">
import 'leaflet'
import 'leaflet/dist/leaflet.css'
import { LMap, LTileLayer, LMarker, LTooltip, LIcon } from '@vue-leaflet/vue-leaflet'

interface Position {
  lat: number;
  lng: number;
}

interface Place {
  id: string;
  name: string;
  icon: string;
  link: string;
  position: Position;
}

interface Props {
  places: Array<Place>;
}

const { isDesktop } = useDevice()

const { places = [] } = defineProps<Props>()

const bounds = computed(() => {
  return places.length
    ? places.map((place: Place) => place.position)
    : [
      { lat: 50.00, lng: 14.00 },
      { lat: 50.00, lng: 24.00 },
      { lat: 54.00, lng: 14.00 },
      { lat: 54.00, lng: 24.00 }
    ]
})

const handleMarkerClick = async ({ link }: Place) => await navigateTo(link)
</script>

<template>
  <LMap
    :use-global-leaflet="true"
    :bounds="bounds"
    :zoom="6"
    :center="[51.90, 19.59]"
    :options="{ zoomAnimation: true, scrollWheelZoom: false, contextMenu: false, dragging: isDesktop }"
  >
    <LTileLayer
      url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
      attribution="&copy; <a href=&quot;http://osm.org/copyright&quot;>OpenStreetMap</a> contributors"
    />
    <LMarkerCluster :options="{ showCoverageOnHover: false, maxClusterRadius: 50 }">
      <LMarker v-for="place in places" :key="place.id" :lat-lng="place.position" @click="handleMarkerClick(place)">
        <LTooltip>
          {{ place.name }}
        </LTooltip>
        <LIcon
          :icon-size="[30, 30]"
          :icon-url="place.icon"
        />
      </LMarker>
    </LMarkerCluster>
  </LMap>
</template>
